var map = {
	"./air-nga-en/assets/play-nav-icon-active.png": 63905,
	"./ais-tai-en/assets/play-nav-icon-active.png": 88302,
	"./ais-tai-tha/assets/play-nav-icon-active.png": 5946,
	"./demo-arabic/assets/play-nav-icon-active.png": 68946,
	"./demo-et-en/assets/play-nav-icon-active.png": 8805,
	"./demo-romanian/assets/play-nav-icon-active.png": 42667,
	"./demo-um-en/assets/play-nav-icon-active.png": 31026,
	"./dtac-tai-en/assets/play-nav-icon-active.png": 31819,
	"./dtac-tai-tha/assets/play-nav-icon-active.png": 26937,
	"./ethiotel-et-amh/assets/play-nav-icon-active.png": 56727,
	"./ethiotel-et-en/assets/play-nav-icon-active.png": 59584,
	"./mtn-cg-fr/assets/play-nav-icon-active.png": 76703,
	"./mtn-ci-fr/assets/play-nav-icon-active.png": 35465,
	"./mtn-cmr-fr/assets/play-nav-icon-active.png": 3117,
	"./mtn-gha-en/assets/play-nav-icon-active.png": 98664,
	"./mtn-nga-en/assets/play-nav-icon-active.png": 65516,
	"./mtn-zam-en/assets/play-nav-icon-active.png": 42034,
	"./saf-ke-en/assets/play-nav-icon-active.png": 45085,
	"./saudi-uae-en/assets/play-nav-icon-active.png": 48098,
	"./tlk-za-en/assets/play-nav-icon-active.png": 50017,
	"./vc-za-en/assets/play-nav-icon-active.png": 41229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74797;